export function isFeatureEnabled(store, featureName) {
  if (!store?.isBackOfficeOnboarded && featureName !== 'XShield') return true;
  if (!Array.isArray(store?.features) && featureName !== 'XShield') return false;
  return store?.features?.includes(featureName);
}

export function filterSidebarMenus(store, menus) {
  const featureToMenuTitle = {
    XShield: 'XShield',
    'Payment Links': 'Payment Links',
    'Payment Routing': 'Payment Routing',
    Subscriptions: 'Subscriptions',
  };
  return menus?.filter((menu) => {
    if (featureToMenuTitle[menu?.title] && store?.isBackOfficeOnboarded && menu?.title !== 'XShield') {
      return isFeatureEnabled(store, menu?.title);
    }
    return true;
  });
}

export function canAccessRoute(store, featureName) {
  return isFeatureEnabled(store, featureName);
}
